"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getElementID = getElementID;
exports.getElementType = getElementType;
exports.getRenderProps = getRenderProps;
exports.isElementInViewport = isElementInViewport;
exports.getSelectorValue = getSelectorValue;
exports.elementHasHorizontalScroll = elementHasHorizontalScroll;
exports.elementHasVerticalScroll = elementHasVerticalScroll;
exports.elementHasScroll = elementHasScroll;
exports.getDocumentHeight = getDocumentHeight;
exports.getDocumentWidth = getDocumentWidth;

var _components = require("./components");

var _types = require("./types");

var _strings = require("./strings");

function getElementID(Component, id) {
  if (id) {
    var componentName = (0, _components.getDisplayName)(Component, null);

    if (componentName) {
      var ids = ['mhub', (0, _strings.lowercaseFirstLetter)(componentName), id];
      return ids.join('-');
    }
  }

  return null;
}

function getElementType(Component) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'as';
  var _Component$defaultPro = Component.defaultProps,
      defaultProps = _Component$defaultPro === void 0 ? {} : _Component$defaultPro;
  var href = props.href;
  var as = props[key];
  var defaultAs = defaultProps[key];

  if (as && ((0, _types.isString)(as) || (0, _types.isFunc)(as)) && as !== defaultAs) {
    return as;
  } // set to link if hkey href


  if (href) {
    return 'a';
  }

  return defaultAs || 'div';
}

function getRenderProps(render) {
  if (render) {
    for (var _len = arguments.length, value = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      value[_key - 1] = arguments[_key];
    }

    if (value && (0, _types.isFunc)(render)) {
      return render.apply(void 0, value);
    }

    return render;
  }

  return null;
}

function isElementInViewport(el) {
  var rect = el.getBoundingClientRect();
  var top = rect.top,
      left = rect.left,
      right = rect.right,
      bottom = rect.bottom;
  var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
  var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
  var topVisible = top >= 0 && top <= viewportHeight;
  var bottomVisible = bottom >= 0 && bottom <= viewportHeight;
  var leftVisible = left >= 0 && left <= viewportWidth;
  var rightVisible = right >= 0 && right <= viewportWidth;
  return (topVisible || bottomVisible) && (leftVisible || rightVisible);
}

function getSelectorValue(data, selector) {
  if (selector) {
    if ((0, _types.isFunc)(selector)) {
      return selector(data);
    }

    if ((0, _types.objHasOwnProperty)(data, selector)) {
      return data[selector];
    }
  }

  return data;
}

function elementHasHorizontalScroll(el) {
  var dir = 'scrollLeft';
  var elem = el;
  var result = !!elem[dir];

  if (!result) {
    elem[dir] = 1;
    result = !!elem[dir];
    elem[dir] = 0;
  }

  return result;
}

function elementHasVerticalScroll(el) {
  var dir = 'scrollTop';
  var elem = el;
  var result = !!elem[dir];

  if (!result) {
    elem[dir] = 1;
    result = !!elem[dir];
    elem[dir] = 0;
  }

  return result;
}

function elementHasScroll(el) {
  return elementHasHorizontalScroll(el) || elementHasVerticalScroll(el);
}

function getDocumentHeight() {
  var _document = document,
      body = _document.body,
      html = _document.documentElement;
  return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
}

function getDocumentWidth() {
  var _document2 = document,
      body = _document2.body,
      html = _document2.documentElement;
  return Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
}